(function(document) {
  'use strict';
  document.addEventListener('readystatechange', function() {
    if (document.readyState === 'complete') {
      let voorkeuren = document.getElementById('contactvoorkeuren');

      if (!voorkeuren) return;

      voorkeuren.addEventListener('submit', (event) => {
        const form = event.target,
        checkError = form.querySelector('.error'),
        checkSucces = document.querySelector('.cv'),
        checkSuccesText = document.querySelector('.cv-intro');

        fetch(form.action, {
          method: form.method,
          body: new FormData(form)
        })
          .then((res) => {
            if (!res.ok) {
              throw Error(res.statusText);
            }
          })
          .then((doc) => {
            checkSucces.classList.remove('is-shown');
            checkSuccesText.classList.add('is-shown');
          })
          .catch((err) => {
            checkError.classList.add('is-shown');
          });

        event.preventDefault();
      });
    }
  });
})(document);
